import { Injectable } from '@angular/core';
import { Time } from '@angular/common';
import { DatePipe } from '@angular/common';

@Injectable ()
export class TripDateService {
  constructor(
    public date: DatePipe
  ) {}

  start = new Date();
  end = new Date(new Date().setDate(new Date().getDate() + 1));
  // end = new Date(this.end1.setHours(this.end1.getHours() + 23));
  startDate = this.date.transform(this.start, 'yyyy/MM/dd');
  endDate = this.date.transform(this.end, 'yyyy/MM/dd');


  getDate() {
    const newDates = {startDate: this.startDate, endDate: this.endDate};
    return (newDates);
  }

  setDates(start, end) {
    this.startDate = start;
    this.endDate = end;
  }
}
